import chroma from 'chroma-js';

export function isWarmColor(color: string): boolean {
  const hue = chroma(color).get('hsl.h');
  return hue < 60 || hue > 330;
}
